import {z} from 'zod/v4';
import {Dateish, objectIdStringZ4} from '@packages/utilities/zod';

export const sourceFolderConstraints = {
  name: {
    minLength: 1,
    maxLength: 256,
  },
} as const;

export type SourceFolder = z.infer<typeof SourceFolder>;
export const SourceFolder = z
  .object({
    id: objectIdStringZ4,
    siteId: objectIdStringZ4,
    parentId: objectIdStringZ4.nullable(),
    name: z
      .string()
      .min(sourceFolderConstraints.name.minLength)
      .max(sourceFolderConstraints.name.maxLength),
    createdAt: Dateish,
    updatedAt: Dateish,
  })
  .describe('A folder in a site-scoped source file tree.');

export type SourceFolderFilter = Pick<
  SourceFolder,
  'siteId' | 'parentId' | 'name'
>;

export type CreateSourceFolder = z.infer<typeof CreateSourceFolder>;
export const CreateSourceFolder = SourceFolder.pick({
  name: true,
  parentId: true,
}).partial({
  parentId: true,
});

export type UpsertSourceFolder = z.infer<typeof UpsertSourceFolder>;
export const UpsertSourceFolder = SourceFolder.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})
  .partial()
  .required({siteId: true, name: true})
  .extend({
    parentId: objectIdStringZ4.nullish(),
  });

export type SourceFolderListResponse = z.infer<typeof SourceFolderListResponse>;
export const SourceFolderListResponse = z.object({
  items: z.array(SourceFolder),
});
